import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CorrelationIdService {
  correlationId: string;

  setCorrelationId(correlationId: string) {
    this.correlationId = correlationId;
  }

  getCorrelationIdAndReset(): string | null | undefined {
    const id = this.correlationId;
    this.correlationId = null;
    return id;
  }
}
